import type { RefOrGetter } from "ls/common/types";
import type { EmojiEntry, EmojiEntrySkin } from "../emojis/data";
import { computed, toValue } from "vue";
import { getPreferredSkinToneEmojiVariant, getUrlFromSkin } from "../emojis/utils";

export function useEmojiEntrySkin(skinVariant: RefOrGetter<EmojiEntrySkin>) {
  const shortCode = computed(() => toValue(skinVariant).shortCodeOmitTone);
  const url = computed(() => getUrlFromSkin(toValue(skinVariant)));

  return {
    shortCode,
    url,
  };
}

export function useEmoji(emoji: EmojiEntry) {
  const skinVariant = computed(() => getPreferredSkinToneEmojiVariant(emoji));
  const { shortCode, url } = useEmojiEntrySkin(skinVariant);

  return {
    skinVariant,
    shortCode,
    url,
  };
}
